import request from '@/utils/infrastructure/communication/request';

export async function queryEditActive({ id, state }) {
  return request.post(`/emailTemplate/activate/${id}/${state}`, {});
}
